module.exports = __webpack_public_path__ + "static/media/technology.99e89b26.jpg";